module.exports = __webpack_public_path__ + "img/adbig.18ae8c72.svg";